import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NameValidator } from '../../validators/name.validator';
import { DelegationService } from '../../../../services/delegation.service';
import { Router } from '@angular/router';
import { ShopService } from '../../../../services/shop.service';
import { EncryptionService } from '../../../../services/EncryptionService';
import { IShop } from '../../../../models/shop.model';
import * as XLSX from "xlsx";
import { Delegation, IDelegation } from '../../../../models/delegation.model';
import { Role } from '../../../../models/role.model';
import { RoleService } from '../../../../services/role.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-delegation',
  templateUrl: './delegation.component.html',
  styleUrls: ['./delegation.component.scss']
})
export class DelegationComponent implements OnInit {
  @ViewChild('closebutton2') closebutton2;

  shop: IShop[] = [];
  delegations: Delegation[] = [];
  search: any;
  pageNumber: number = 1;
  pageSize: number = 15;
  totalItems: number;
  restRoles: Role[] = [];
  selectedItemsPerm = [];
  dropdownSettings = {};
  shopDropdownSettings = {};

  constructor(private fb: FormBuilder, private delegationService: DelegationService,
            private router: Router, private shopService: ShopService, private encryptionService: EncryptionService,
            private roleService: RoleService,) { }

  ngOnInit(): void {
    this.getDelegations();
    this.dropdownSettings = {
      singleSelection: false,
      text: ' *** Sélectionnez les rôles ***',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      primaryKey: 'id',
      labelKey: 'itemName',
      enableCheckAll: true,
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout désélectionner',
      showCheckbox: true,
      enableFilterClear: true
    };

    this.shopDropdownSettings = {
      singleSelection: false,
      text: ' *** Sélectionnez les boutiques ***',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      primaryKey: 'id',
      labelKey: 'name',
      enableCheckAll: true,
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout désélectionner',
      showCheckbox: true,
      enableFilterClear: true
    };
    this.loadRoles();
  }

  private loadRoles() {
    this.roleService.getRole().subscribe(rs => {
      this.restRoles = rs;
      this.restRoles.map(val => {
        // @ts-ignore
        val.itemName = val.name;
      });
    });
  }

  delegationForm = this.fb.group({
    deleguantUsername: ['', [Validators.required, Validators.maxLength(14), NameValidator.notOnlyWhitespace, Validators.pattern('^[A-Za-z0-9 -]+$')]],
    delegueUsername: ['', [Validators.required, Validators.maxLength(14), NameValidator.notOnlyWhitespace, Validators.pattern('^[A-Za-z0-9 -]+$')]],
    // roleId: new FormControl('', Validators.required),
    roles: new FormControl([], []),
    shopId: new FormControl('', Validators.required),
  });

  // Only AlphaNumeric
  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getDelegations = () => {
    this.delegationService.loadAllDelegation(this.pageNumber - 1, this.pageSize).subscribe((data) => {
        this.delegations = data.content;
        this.totalItems = data.totalElements;
        console.log(this.delegations);
      })
  };

  searchFilter(){
    this.delegationService.loadAllDelegation(this.pageNumber - 1, this.pageSize, this.search)
      .subscribe((data) => {
        this.delegations = data.content;
        this.totalItems = data.totalElements;
        console.log(this.delegations);
      });
  }

  // @ts-ignore
  currentUser: IDelegation = [];

  onViewUser(tr: any) {
      this.currentUser = tr;
      console.log(this.currentUser)
    }

  deleteUser(id: number) {
      Swal.fire({
        title: 'Voulez-vous vraiment supprimer ce gestionnaire de la boutique ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonText: 'Non',
        confirmButtonText: 'Oui'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delegationService.deleteUser(id, true).subscribe(
            rs=> {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Le gestionnaire de la boutique a été supprimé avec succès.',
                showConfirmButton: false,
                timer: 1500
              });
              this.reloadComponent();
            }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 1500
              })
            }
          )
        }
      })
  }

  onTableSizeChange(value: any) {
    console.log(value)
    this.pageSize = value;
    this.getDelegations();
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  sorted = 1;
  // trier(columnName: keyof any) {
  //   this.sorted = -this.sorted;
  //   this.delegations.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  // }
  trier(columnName: string) {
    this.sorted = -this.sorted;

    this.delegations.sort((a, b) => {
        const valueA = this.getNestedValue(a, columnName);
        const valueB = this.getNestedValue(b, columnName);

        // Cas où les valeurs sont nulles ou undefined
        if (valueA == null && valueB == null) {
            return 0;
        }
        if (valueA == null) {
            return this.sorted;
        }
        if (valueB == null) {
            return -this.sorted;
        }

        // Comparaison des chaînes de caractères
        if (typeof valueA === 'string' && typeof valueB === 'string') {
            const normalizedA = valueA.toLowerCase();
            const normalizedB = valueB.toLowerCase();
            return normalizedA < normalizedB ? -this.sorted : normalizedA > normalizedB ? this.sorted : 0;
        }

        // Comparaison des nombres
        if (typeof valueA === 'number' && typeof valueB === 'number') {
            return valueA < valueB ? -this.sorted : valueA > valueB ? this.sorted : 0;
        }

        // Comparaison des dates
        if (valueA instanceof Date && valueB instanceof Date) {
            return valueA.getTime() < valueB.getTime() ? -this.sorted : valueA.getTime() > valueB.getTime() ? this.sorted : 0;
        }

        // Cas par défaut (si types différents ou autres)
        return 0;
    });
}


getNestedValue(obj: any, path: string) {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

 

  onSubmit(){}

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  close() {
    this.closebutton2.nativeElement.click();
  }

  onItemSelect(item: any) {
    // console.log(item);
    // console.log(this.selectedItemsPerm);
  }

  OnItemDeSelect(item: any) {
    // console.log(item);
    // console.log(this.selectedItemsPerm);
  }

  onSelectAll(items: any) {
    // console.log(items);
  }
  onDeSelectAll(items: any) {
    // console.log(items);
  }

  getTemporaryAgregation(delegation: any){
    this.agregate = delegation;
    console.log(this.agregate)
    forkJoin({
      shops: this.shopService.loardSellerShop(delegation.delegantUserName),
      roles: this.roleService.getRole()
    }).subscribe({
      next: ({ shops, roles }) => {
        this.shop = shops;
        this.shop = this.shop.filter(shop => shop.id === delegation.objectId);
        this.restRoles = roles
          .filter(role => role.name === "-VALIDEUR_COMMANDES-" || role.name === "-VALIDEUR_CODES_PAIEMENT-")
          .map(val => ({ ...val, itemName: val.displayName }));

        console.log('Boutiques chargées:', this.shop);
        console.log('Rôles chargés:', this.restRoles);

        this.edit(); // Pré-remplir après chargement
      },
      error: (err) => {
        console.error('Erreur lors du chargement des données:', err);
      }
    });

    this.agregateForm.get('roles')?.valueChanges.subscribe(value => {
      console.log('Valeur de roles changée : ', value);
    });

    this.agregateForm.get('objectId')?.valueChanges.subscribe(value => {
      console.log('Valeur de objectId changée : ', value);
    });
  }

  agregateForm = this.fb.group({
    delegueUsername: [{ value: '', disabled: true }, [Validators.required, Validators.maxLength(14), NameValidator.notOnlyWhitespace, Validators.pattern('^[A-Za-z0-9 -]+$')]],
    roles: new FormControl([], Validators.required),
    objectId: new FormControl([], Validators.required)
  });

  formSubmitted: boolean = false;
  onFormSubmit(event: Event): void {
    event.preventDefault();
    this.formSubmitted = true;

    if (this.agregateForm.valid) {
      const selectedRoles = this.agregateForm.get('roles')?.value || [];
      const selectedShops = this.agregateForm.get('objectId')?.value || [];

      if (selectedRoles.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Attention', text: 'Veuillez sélectionner au moins un rôle.' });
        return;
      }

      if (selectedShops.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Attention', text: 'Veuillez sélectionner au moins une boutique.' });
        return;
      }

      const roleIds = selectedRoles.map(role => role.id);
      const objectIds = selectedShops.map(shop => Number(shop.id));

      const updatedData: IDelegation = {
        id: this.agregate.id,
        delegantUsername: this.agregate.delegantUserName,
        delegueUsername: this.agregateForm.get('delegueUsername')?.value,
        roleId: roleIds, // Envoyé comme tableau d’IDs
        objectId: objectIds,
      };

      console.log('Sending data to backend:', updatedData);

      this.delegationService.updateAgregate(updatedData, true).subscribe(
        () => {
          Swal.fire({
            icon: 'success',
            title: 'Succès',
            text: 'L\'utilisateur a été modifié avec succès.',
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            // this.onClose();
            this.reloadComponent();
          });
        },
        (error) => {
          Swal.fire({ icon: 'error', title: 'Erreur', text: 'Erreur lors de la mise à jour de l\'agrégation.' });
          console.error(error);
        }
      );
    } else {
      Swal.fire({ icon: 'warning', title: 'Attention', text: 'Veuillez remplir tous les champs correctement.' });
    }
  }

  agregate: IDelegation | any;
  selectedShops: IShop[] = [];
  edit() {
    if (this.agregate && this.restRoles.length > 0 && this.shop.length > 0) {
      // Pré-remplir les rôles sélectionnés à partir de this.agregate.roles
      if (this.agregate.roleDtos && Array.isArray(this.agregate.roleDtos)) {
        const roleIds = this.agregate.roleDtos.map((role: any) => role.id); // Extraire les IDs depuis roles
        this.selectedItemsPerm = this.restRoles.filter(role => roleIds.includes(role.id));
        // console.log('Rôles pré-remplis:', this.selectedItemsPerm);
      } else if (this.agregate.roleId && Array.isArray(this.agregate.roleId)) {
        // Gérer le cas où roleId est présent (compatibilité avec l’ancienne structure)
        this.selectedItemsPerm = this.restRoles.filter(role => this.agregate.roleId.includes(role.id));
        // console.log('Rôles pré-remplis (via roleId):', this.selectedItemsPerm);
      } else {
        console.warn('Aucun rôle trouvé dans agregate (ni roles ni roleId).');
        this.selectedItemsPerm = [];
      }

      // Pré-remplir les boutiques sélectionnées
      if (this.agregate.objectId) {
        const objectIds = Array.isArray(this.agregate.objectId) ? this.agregate.objectId : [this.agregate.objectId]; // Gérer valeur unique ou tableau
        this.selectedShops = this.shop.filter(shop => objectIds.includes(shop.id));
        console.log('Boutiques pré-remplies:', this.selectedShops);
      } else {
        console.warn('Aucun objectId trouvé dans agregate.');
        this.selectedShops = [];
      }

      this.agregateForm.patchValue({
        delegueUsername: this.agregate.delegueUserName,
        roles: this.selectedItemsPerm,
        objectId: this.selectedShops
      });

      console.log('Formulaire après pré-remplissage:', this.agregateForm.value);
      this.agregateForm.updateValueAndValidity();
    } else {
      console.warn('Données non prêtes pour le pré-remplissage:', {
        agregate: this.agregate,
        restRoles: this.restRoles.length,
        shop: this.shop.length
      });
    }
  }
}
